import {arrayToOptions} from './array-to-options.js'

const years = ['2020', '2021', '2022', '2023', '2024', '2025', '2026', '2027', '2028', '2029', '2030']
const quarters = ['Q1', 'Q2', 'Q3', 'Q4']
const times = ['Yearly', 'Quarterly', 'Monthly']
const orderTypes = ['Hold', 'Worksheet', 'PO', 'In Progress', 'Shipped']
const reportTypes = ['Sales', 'Inventory']
const reportTypesSuperAdmin = reportTypes.concat(['VPO', 'Future Purchases', 'Historical Purchases'])
const inventoryTypes = ['ATS + Future ATS', 'ATS', 'Future ATS', 'On Hand', 'RTS', 'Future Stock', 'All Styles']
const summaryPage = ['Units', 'Dollars']
const inSeason = ['In Season', 'Upfront', 'Missing']
const inSeasonWithAll = ['All', 'In Season', 'Upfront']
const margin = ['Low', 'Avg', 'Good', 'Great']

const yearOptions = arrayToOptions(years)
const quarterOptions = arrayToOptions(quarters)
const timeOptions = arrayToOptions(times)
const orderTypeOptions = arrayToOptions(orderTypes)
const reportTypeOptions = arrayToOptions(reportTypes)
const reportTypesSuperAdminOptions = arrayToOptions(reportTypesSuperAdmin)
const inventoryTypeOptions = arrayToOptions(inventoryTypes)
const summaryPageOptions = arrayToOptions(summaryPage)
const inSeasonOptions = arrayToOptions(inSeason)
const inSeasonOptionsWithAll = arrayToOptions(inSeasonWithAll)
const marginOptions = arrayToOptions(margin)

export {yearOptions, quarterOptions, timeOptions, orderTypeOptions, reportTypeOptions, reportTypesSuperAdminOptions, inventoryTypeOptions, summaryPageOptions, marginOptions, inSeasonOptions, inSeasonOptionsWithAll}
